import application from 'application/application';

import moment from 'moment';

application

	.directive('ngHour', () => ({
		restrict: 'A',
		require: 'ngModel',
		link(scope, element, attrs, controller) {

			controller.$validators.date = modelValue => {

				if (controller.$isEmpty(modelValue))

					return true;

				return moment(modelValue, (attrs.ngDateFormat || 'HH:mm'), true).isValid();

			};

		}
	}));
